<script>
export default {
  name: "DataTableModal",
  components: {},
  mixins: [],
  props: {
    /**
     * モーダル表示制御
     */
    enable: {
      type: Boolean,
      default: false
    },
    /**
     * 説明
     */
    descriptions: {
      type: [Array, String],
      default: () => null
    },
    /**
     * テーブルのヘッダー
     */
    headers: {
      type: Array,
      default: () => [],
    },
    /**
     * テーブルに展開する情報
     */
    items: {
      type: Array,
      default: () => [],
    },
    positive: {
      type: Boolean,
      default: false
    },
    positiveCaption: {
      type: String,
      default: '登録'
    }
  },
  data() {
    return {

    }
  },
  computed: {
    convertedDescriptions () {
      if (Array.isArray(this.descriptions)) {
        return this.descriptions;
      } else {
        return [this.descriptions];
      }
    },
  },
  watch: {

  },
  created () {

  },
  methods: {

    closeButtonClick () {
      this.$emit('close')
    },

    positiveButtonClick () {
      this.$emit('positiveCallback')
    },
  }
}
</script>

<template>
  <v-dialog
    :value="enable"
    persistent
    scrollable
    width="900"
    @keydown.esc="closeButtonClick"
    @close="closeButtonClick"
  >
    <v-card flat>
      <v-card-title
        v-if="descriptions"
        class="pl-3"
      >
        <div
          v-for="(description, index) in convertedDescriptions"
          :key="index"
          class="text-body-1 text-break"
        >
          {{description}}
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-2 mt-2">
        <v-sheet outlined rounded>
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="-1"
            class="mb-2"
            disable-sort
            fixed-header
            height="35vh"
            hide-default-footer
          >
            <template v-slot:[`item.manifest_no`]="{item}">
              {{ item.manifest_no || '-' }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClick">閉じる</v-btn>
        <v-btn v-if="positive" color="primary" @click="positiveButtonClick">{{ positiveCaption }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
